import { combineReducers } from 'redux';
import me from './me';
import * as fromMe from './me';
import groups from './groups/groups';
import * as fromGroups from './groups/groups';
import del from './del';
import * as fromDel from './del';
import currentTab from './currentTab';
import * as fromCurrentTab from './currentTab';

export default combineReducers({
  me,
  groups,
  del,
  currentTab,
});

export const getPermissionsByTenant = (state) => fromMe.getPermissionsByTenant(state.me);

export const isFetchingMyPermissions = (state) => fromMe.isFetchingMyPermissions(state.me);

export const getUpdatingGroup = (state) => fromGroups.getUpdatingGroup(state.groups);

export const isUpdatingGroup = (state) => fromGroups.isUpdatingGroup(state.groups);

export const getGroups = (state) => fromGroups.getGroups(state.groups);

export const isFetchingGroups = (state) => fromGroups.isFetchingGroups(state.groups);

export const isDeletingEntity = (state) => fromDel.isDeleting(state.del);

export const getTabKey = (state) => fromCurrentTab.getTabKey(state.currentTab);
